import { render } from "./PersonaAtencion.vue?vue&type=template&id=1cf7cb31&scoped=true"
import script from "./PersonaAtencion.vue?vue&type=script&lang=js"
export * from "./PersonaAtencion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=1cf7cb31&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf7cb31"]])

export default __exports__